// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__BEcUk","wide":"Theme_wide__2Fqrc","input":"Theme_input__nqIA3","inner":"Theme_inner__1cfGu","box":"Theme_box__cR05D"};